import { render, staticRenderFns } from "./ChainCard.vue?vue&type=template&id=a7b82fe8&scoped=true&lang=pug&"
import script from "./ChainCard.vue?vue&type=script&lang=js&"
export * from "./ChainCard.vue?vue&type=script&lang=js&"
import style0 from "./ChainCard.vue?vue&type=style&index=0&id=a7b82fe8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7b82fe8",
  null
  
)

export default component.exports